/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Heading } from 'sarsaparilla';

const propTypes = {
    title: PropTypes.string,
    url: PropTypes.string,
};

const defaultProps = {
    title: '',
    url: '',
};

export default function Video(props) {
    const videoComponent = () => (
        <div>
            <iframe title={props.title} width="420" height="315" src={props.url} />
        </div>
    );

    return (
        <div>
            <Heading appearance="h5" headingLevel={2}>
                {props.title}
            </Heading>
            {videoComponent()}
        </div>
    );
}

Video.propTypes = propTypes;
Video.defaultProps = defaultProps;
